import { render, staticRenderFns } from "./modal-task-waterfall.vue?vue&type=template&id=3cd8ff77&"
import script from "./modal-task-waterfall.vue?vue&type=script&lang=js&"
export * from "./modal-task-waterfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports